import { Button, ButtonGroup } from '@mui/material';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';

type PositionControlProps = {
    index: number;
    maxIndex: number;
    onIndexChange: (previousIndex: number, newIndex: number) => void;
};

export const PositionControl = ({ index, maxIndex, onIndexChange }: PositionControlProps) => {
    return (
        <ButtonGroup orientation="vertical">
            <Button size="small" disabled={index === 0} onClick={() => onIndexChange(index, index - 1)}>
                <ArrowUpOutlined />
            </Button>
            <Button size="small" disabled={index === maxIndex} onClick={() => onIndexChange(index, index + 1)}>
                <ArrowDownOutlined />
            </Button>
        </ButtonGroup>
    );
};
